import React from "react";
import { Typography } from "antd";
import styled, { css } from "styled-components";
import { ColorPalette } from "./color/colorPalette";
import { QuestionCircleOutlined } from "@ant-design/icons";

interface CustomLabelProps {
  customSize?: "XLarge" | "Large";
  state?: "Valid" | "Invalid" | "Disable";
  hint?: boolean;
  customRequired?: boolean;
  children?: any;
  style?: React.CSSProperties;
}

const sizeStyles = css<{ customSize?: "XLarge" | "Large" }>`
  ${(props) =>
    props.customSize === "XLarge" &&
    css`
      padding: 8px 0px;
    `}
  ${(props) =>
    props.customSize === "Large" &&
    css`
      padding: 4px 0px;
    `}
`;

const stateStyles = css<{
  state?: "Valid" | "Invalid" | "Disable";
}>`
  ${(props) =>
    props.state === "Valid" &&
    css`
      color: ${ColorPalette.gray[900]};
    `}
  ${(props) =>
    props.state === "Invalid" &&
    css`
      color: ${ColorPalette.red[300]};
    `}

    ${(props) =>
    props.state === "Disable" &&
    css`
      color: ${ColorPalette.gray[400]};
    `}
`;

const StyledCustomLabel = styled(Typography)<{
  customSize?: "XLarge" | "Large";
  hint?: true | false;
  state?: "Valid" | "Invalid" | "Disable";
  customRequired?: true | false;
}>`
  display: inline-flex;
  padding: 4px 0px;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;

  ${sizeStyles}
  ${stateStyles}
  .
`;

const CustomLabel: React.FC<CustomLabelProps> = ({
  customSize,
  state,
  hint,
  customRequired,
  children,
  style,
  ...props
}) => {
  let color;
  switch (state) {
    case "Valid":
      color = ColorPalette.gray[900];
      break;
    case "Invalid":
      color = ColorPalette.red[300];
      break;
    case "Disable":
      color = ColorPalette.gray[400];
      break;
  }

  return (
    <StyledCustomLabel
      {...props}
      customSize={customSize}
      hint={hint}
      state={state}
      customRequired={customRequired}
    >
      <Typography.Text
        style={{
          textAlign: "right",
          fontFamily: "YekanBakhVF",
          fontSize: customSize === "Large" ? "16px" : "18px",
          color: color,
          fontStyle: "normal",
          fontWeight: 325,
          lineHeight: "180%",
          textTransform: "capitalize",
          ...style,
        }}
      >
        {children}
        {!hint && !customRequired && (
          <Typography.Text
            style={{
              fontFamily: "YekanBakhVF",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "24px",
              color: color,
              ...style,
            }}
          ></Typography.Text>
        )}
      </Typography.Text>

      {customRequired && (
        <Typography.Text
          style={{
            fontFamily: "YekanBakhVF",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "24px",
            color: ColorPalette.red[300],
            ...style,
          }}
        >
          *
          {!hint && (
            <Typography.Text
              style={{
                fontFamily: "YekanBakhVF",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "24px",
                color: color,
                ...style,
              }}
            >
              :
            </Typography.Text>
          )}
        </Typography.Text>
      )}

      {hint && (
        <>
          <QuestionCircleOutlined
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              color: ColorPalette.gray[900],
            }}
          />
          {
            <Typography.Text
              style={{
                fontFamily: "YekanBakhVF",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "24px",
                color: color,
              }}
            >
              :
            </Typography.Text>
          }
        </>
      )}
    </StyledCustomLabel>
  );
};

export default CustomLabel;
